// extracted by mini-css-extract-plugin
export default {"tooltip":"KX-z","arrow":"LX-z"};